<div class="container">
  <div class="row contact-us">
    <div class="d-none d-lg-block col-lg-1 custom-col-padding"></div>
    @if (!userAuthenticated || !dataLoaded) {
      <div class="col loading-content custom-col-padding">
        <olb-app-loading></olb-app-loading>
      </div>
    }
    @if (userAuthenticated && dataLoaded) {
      <div class="col main-content custom-col-padding">
        <olb-app-chat-info></olb-app-chat-info>
        <olb-app-useful-links></olb-app-useful-links>
        <olb-app-call-us></olb-app-call-us>
      </div>
    }
    <div class="d-none d-lg-block col-lg-1 custom-col-padding"></div>
  </div>
</div>
